import React from 'react'
import css from './styles.module.scss'
import Text from 'components/typo/Text'
import Typo from 'components/typo/Typo'
import Image from 'components/shared/Image'

const BenefitRow = ({ title, text, icon }) => {
  return (
    <div className={css.wrapper}>
      <div className={css.border} />
      <div className={css.content}>
        <div className={css.titleRow}>
          <Image
            className={css.image}
            media={{ width: 32, height: 32 }}
            fluid
            {...icon}
            alt=""
          />
          <div className={css.column}>
            <Typo className={css.title}>{title}</Typo>
          </div>
        </div>
        <Text className={css.description}>{text}</Text>
      </div>
    </div>
  )
}

export default BenefitRow
